// extracted by mini-css-extract-plugin
module.exports = {"invite":"e_Oy","link":"e_Py"};